import Reveal from "./Reveal";
import { Container, Eyebrow } from "./Primitives";

const ITEMS = [
  { title: "Know AI can help, but need clarity", body: "On which tools to use and where to start." },
  { title: "Want AI expertise without building an expensive internal department." },
  { title: "Want one accountable team to manage delivery", body: "Without spending weeks coordinating individual freelancers." },
];

export default function ForWho() {
  return (
    <section className="bg-panel py-24 sm:py-32">
      <Container>
        <div className="grid gap-12 lg:grid-cols-[1fr_1.4fr] lg:gap-24">
          <Reveal>
            <Eyebrow className="text-tone">For Who</Eyebrow>
            <h2 className="mt-6 font-display text-4xl font-light leading-[1.04] tracking-[-0.04em] text-fg sm:text-5xl">
              You see the opportunity. We make it work.
            </h2>
            <p className="mt-6 text-base text-subtle md:text-lg">For business and organization leaders who:</p>
          </Reveal>
          <ul className="grid gap-3 self-end">
            {ITEMS.map((it, i) => (
              <Reveal as="li" key={it.title} delay={i * 80} className="border border-fg/15 bg-canvas px-6 py-5">
                <h3 className="font-display text-[17px] font-medium leading-snug tracking-[-0.01em] text-fg">{it.title}</h3>
                {it.body && <p className="mt-1.5 text-[15px] leading-relaxed text-subtle">{it.body}</p>}
              </Reveal>
            ))}
          </ul>
        </div>
        <Reveal className="mt-16 border-t border-fg/10 pt-8">
          <p className="font-display text-xl font-light tracking-[-0.02em] text-fg sm:text-2xl">
            Your Fractional AI Department. <span className="text-subtle">From business need to working solution.</span>
          </p>
        </Reveal>
      </Container>
    </section>
  );
}
